module.exports = __webpack_public_path__ + "media/images/authentication/login-3edf03e6bfd1ee636be4c72d3541d15d.png";